import { sharedThemeTokens } from '@/templates/sharedThemeTokens.js';

export const templateThemeTokens = {
  ...sharedThemeTokens,
};
